export function formatMoney(
  amount: number,
  currency: string,
  locale: string,
  fractionDigits?: number,
) {
  const digits = fractionDigits ?? (amount >= 1000 ? 0 : 2)
  return `${formatNumber(amount, locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })} ${currency}`
}

export function formatNumber(amount: number, locale: string, options?: Intl.NumberFormatOptions) {
  const formatOptions = {
    ...options,
    minimumFractionDigits: options?.minimumFractionDigits ?? 0,
    maximumFractionDigits: options?.maximumFractionDigits ?? 0,
  }
  return amount.toLocaleString(locale, formatOptions)
}

const RATE_PRECISION_6_DECIMAL_PLACES_THRESHOLD = 0.0001
const RATE_PRECISION_4_DECIMAL_PLACES_THRESHOLD = 0.1
const RATE_PRECISION_0_DECIMAL_PLACES_THRESHOLD = 1000

function getPrecision(exchangeRate: number) {
  if (exchangeRate > RATE_PRECISION_0_DECIMAL_PLACES_THRESHOLD) return 0
  if (exchangeRate > RATE_PRECISION_4_DECIMAL_PLACES_THRESHOLD) return 4
  if (exchangeRate > RATE_PRECISION_6_DECIMAL_PLACES_THRESHOLD) return 6
  return 8
}

export function formatRate(exchangeRate: number, locale = 'en') {
  const precision = getPrecision(exchangeRate)

  return exchangeRate.toLocaleString(locale, {
    useGrouping: false,
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  })
}
